import React from 'react';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import { Button, Modal} from 'react-bootstrap';

import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';

import Bookingcalendar from '../../../Shared/Bookingcalendar/Bookingcalendar';
import Field from '../../../Shared/Wizard/Field/Field';
import { useAuth } from '../../../../Auth';

function EventResources(props) {
    const t = useTranslate();
    const auth = useAuth();

    const [showBookingPicker, setShowBookingPicker] = React.useState(false);
    const [bookingPickerValues, setBookingPickerValues] = React.useState<any>(undefined);
    
    const [selectedBookingUUID, setSelectedBookingUUID] = React.useState<any>(undefined);
    
    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });


    //let resourceInEvent =  props.allResources.filter(r => ([].concat.apply([], r.bookings.map(b => b.eventId)) as Array<any>).includes(props.event._id?.toString()));
    

    function addSpecificResourceList(resource) {
        
        let tempAllResources = props.allResources;

        let foundResource = tempAllResources.find(i => i._id == resource._id);

        if (foundResource.bookings.some(b => {
            return b.bookingtimes.some(bt => {
                return props.event.periods.some(p => {
                    return (new Date(bt.start) <= new Date(p.to)) && (new Date(p.from) <= new Date(bt.end))
                });
            });
        })) {
            let overlap = window.confirm("Overlappende booking! Er du sikker på at du vil fortsette?");
            if (!overlap) {
                return;
            }
        }

        let newResourceEvent: any = {
            bookingId: "",
            eventId: [],
            bookingtimes: [],
            people: [],
            state: "reserved",
            uuid: uuidv4(),
            reservedFrom: props.event._id
        };

        newResourceEvent.eventId.push(props.event._id);

        if (props.event != undefined) {
            let addBookingTimes:Array<any> = [];
            props.event.periods.forEach(period => {
                
                addBookingTimes.push({
                    eventId: props.event._id,
                    start: period.from,
                    end: period.to,
                    uuid: uuidv4(),
                    state: "reserved",
                });
            });

            //if(foundResource.bookings.find(b => b.eventId.includes(props.event._id)) == undefined) {
                newResourceEvent.bookingtimes = addBookingTimes;
                foundResource.bookings.push(newResourceEvent);
                foundResource["changed"] = true;
            //} else {
            //    let resourceBooking = foundResource.bookings.find(b => b.eventId.includes(props.event._id));
            //    foundResource.bookings = foundResource.bookings.filter(b => b.uuid != resourceBooking.uuid);
            //
            //    resourceBooking.bookingtimes = [...resourceBooking.bookingtimes, ...addBookingTimes];
            //    foundResource.bookings.push(resourceBooking);
            //};

            foundResource.bookings = foundResource.bookings.filter(b => b.bookingtimes.length != 0);

            if (props.onChange != undefined) {
                props.onChange(JSON.parse(JSON.stringify(foundResource)));
            }

            localStorage.setItem("editedItems", "true");

        }

   
        
    }

    const deleteResourceList = (key) => {
        let foundResource = props.allResources.find(r => r._id == props.resourcesInEvent[key]["_id"]);

        if(foundResource != undefined && foundResource.bookings != undefined){
            //This line edits .bookings by reference. Changes are made directly to props
            foundResource.bookings = foundResource.bookings.filter(b => !([].concat.apply([], b.eventId) as Array<any>).includes(props.event._id.toString()));

            props.onChange(JSON.parse(JSON.stringify(foundResource)));
        } 
        
        localStorage.setItem("editedItems", "true");
    }

    function clickCreateBookingtime(resource, date, selectedBookingUUID: any = undefined) {
        let tempresources = props.allResources;
    
        let clickedResource = tempresources.find(i => i._id == resource._resource.id);

        if (clickedResource != undefined) {
            clickedResource["changed"] = true;
            let foundBookings = clickedResource.bookings != undefined ? clickedResource.bookings.filter(i => i.eventId == props.event._id) : [];
            if (selectedBookingUUID != undefined) {
                foundBookings = foundBookings.filter(i => i.uuid == selectedBookingUUID);
            }

            if (foundBookings.length == 1) {
                foundBookings[0].bookingtimes.push({
                    bookingId: "",
                    eventId: props.event._id,
                    start: moment(date).add(1, "hours").toDate(),
                    end: moment(date).add(25, "hours").toDate(),
                    uuid: uuidv4(),
                    state: "reserved"
                });
            } else if (foundBookings.length > 1) {
                setBookingPickerValues({
                    resource: resource,
                    date: date,
                    foundBookings: foundBookings
                });
                setShowBookingPicker(true);
            } else {
                notifyWarning(t("booking.resources.add_before_assigning_time"));
            }
        }

        if (props.onResourcesChange != undefined) {
            props.onResourcesChange(JSON.parse(JSON.stringify(tempresources)));
        }
        localStorage.setItem("editedItems", "true");
    }

    return (
        <div style={{ marginTop: '20px' }}>
            <h3>{t("event.eventResources.title")}</h3>
                <Bookingcalendar
                    fetchDataPass={() => {
                        if (props.fetchDataPass != undefined) {
                            props.fetchDataPass();
                        }
                    }}
                    event={props.event}
                    forceUpdate={props.forceUpdate}
                    height={"600px"}
                    resources={
                        props.allResources.map(resource => {
                            let resourceType = props.allResourceTypes.find(i => i._id == resource.resourceType);
                            return {...resource, resourceTypeName: (resourceType != undefined ? resourceType.name : "") };
                        })
                    }

                    resourceClicked={(resource) => {
                        if (auth.user["userdata"]["orgRole"][0] != "janitor") {
                            if (props.allResources != undefined) {
                                if (!props.allResources.map(r => r.resource).includes(resource._id)) {
                                    addSpecificResourceList(resource);
                                }
                            } else {
                                addSpecificResourceList(resource);
                            }
                        }
                    }}
                    dateClick={(evt) => {
                        if (auth.user["userdata"]["orgRole"][0] != "janitor") clickCreateBookingtime(evt.resource, evt.date);
                    }}
                    onChange={(resources) => {
                        resources.forEach(resource => {
                            if(props.resourcesInEvent.find(x => x._id == resource._id) != undefined){
                                resource["changed"] = true;
                                let booking = resource.bookings.find(book => book.eventId == props.event._id);
                                if(booking == undefined || booking.bookingtimes.length == 0){
                                    resource.bookings.splice(props.resourcesInEvent.findIndex(x => x._id == resource._id), 1);
                                }
                            }
                             
                        });
                        
                        if (props.onResourcesChange != undefined) {
                            props.onResourcesChange(JSON.parse(JSON.stringify(resources)));
                        }
                        localStorage.setItem("editedItems", "true");
                    }}
                    clickable={auth.user["userdata"]["orgRole"][0] != "janitor"}
                ></Bookingcalendar>
            <hr/>
            <h3>{t("event.eventResources.resourcestitle")}</h3>
            <table className="table resourcedefinitiontable">
                <thead>
                    <tr>
                        <th>{t("event.eventResources.resource")}</th>
                        <th>{t("event.eventResources.status")}</th>
                        <th>{t("event.eventResources.delete")}</th>
                    </tr>
                </thead>
                <tbody>
                    {props.resourcesInEvent != undefined ? props.resourcesInEvent.map((resource, key)=> 
                        <tr key={key}>
                            <td>{resource != undefined ? resource.name : null}</td>
                            <td>{resource != undefined ?
                                resource.bookings.map((booking, bookingkey) => {
                                    if (booking.eventId == props.event._id) {
                                        return booking.state == "reserved" ?
                                            t("event.eventResources.status_reserved") + " (" + bookingkey + ")"
                                        :
                                            t("event.eventResources.status_occupied") + " (" + bookingkey + ")"
                                    } else {
                                        return null;
                                    }
                                }).filter(b => b != null).join(", ")
                            : null}</td>
                            <td>
                                { auth.user["userdata"]["orgRole"][0] != "janitor" ?
                                    <Button onClick={(evt) => deleteResourceList(key)}>{t("event.eventResources.delete")}</Button>
                                : null}
                            </td>
                        </tr>
                    ) : null}
                </tbody>
            </table>
            <Modal size="lg" show={showBookingPicker} onHide={() => {
                setShowBookingPicker(false);
            }}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("event.eventResources.selectbooking.title")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="bookingcalendarmodaleditevent">
                    <p>{t("event.eventResources.selectbooking.info")}</p>
                    <Field
                        type="select"
                        options={{
                            choosetext: t("event.eventResources.selectbooking.choosetext"),
                            choices: bookingPickerValues?.foundBookings?.map(b => {
                                let booking = props.allBookings.find(c => c._id == b.bookingId);
                                let customer = props.allCustomers.find(c => c._id == booking.customerId);
                                
                                return {
                                    value: b.uuid,
                                    label: (customer?.organizationName ?? "") + ": " + (booking?.bookingnumber ?? "")
                                }
                            }) ?? []
                        }}
                        value={selectedBookingUUID}
                        onChange={(val) => {
                            setSelectedBookingUUID(val.value);
                        }}
                    ></Field>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => {
                        setShowBookingPicker(false);
                        setBookingPickerValues(undefined);
                    }}>
                        {t("event.eventResources.selectbooking.cancel")}
                    </Button>
                    <Button onClick={(evt) => {
                        clickCreateBookingtime(bookingPickerValues.resource, bookingPickerValues.date, selectedBookingUUID);

                        setShowBookingPicker(false);
                        setBookingPickerValues(undefined);
                        setSelectedBookingUUID(undefined);
                    }}>
                        {t("event.eventResources.selectbooking.create")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}


export default EventResources;